import React, { forwardRef } from 'react';
import './Input.css'; // Reuses same styles

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  hint?: string;
  options: Array<{ value: string | number; label: string; disabled?: boolean }>;
  placeholder?: string;
  fullWidth?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label, error, hint, options, placeholder, fullWidth = true,
  className = '', id, ...props
}, ref) => {
  const selectId = id || `select-${label?.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className={`ui-input-group ${fullWidth ? 'ui-input-full' : ''} ${error ? 'ui-input-error' : ''} ${className}`}>
      {label && <label htmlFor={selectId} className="ui-input-label">{label}</label>}
      <select ref={ref} id={selectId} className="ui-input ui-select" {...props}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(opt => (
          <option key={opt.value} value={opt.value} disabled={opt.disabled}>{opt.label}</option>
        ))}
      </select>
      {error && <span className="ui-input-error-text">{error}</span>}
      {hint && !error && <span className="ui-input-hint">{hint}</span>}
    </div>
  );
});
Select.displayName = 'Select';
